module.exports = __webpack_public_path__ + "static/media/transpetroleumlogo.b21afb84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/transpetroleumlogo.jpg
// module id = 445
// module chunks = 0